'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PZTab = function PZTab(props) {
  var tabs = Array.from(Object.keys(props.pzTabs), function (k) {
    return props.pzTabs[k];
  });
  var sorted_tabs = tabs.sort(function (a, b) {
    return a.sort_id - b.sort_id;
  });
  return React.createElement(
    'div',
    { className: 'pz-custom-item-content' },
    sorted_tabs.map(function (pzTab, index) {
      //let pzTab = props.pzTabs[pzTabKey];

      var canvasObj = props.HomeComponent.pzCanvasObjectGetItemByFieldName('tabId', pzTab.promize_tab_id);
      var selectedOptionstyle = {};
      var selectedOption = '';
      if (canvasObj && canvasObj.customType == "option") {
        if (!canvasObj.option_name.toLowerCase().includes('back side of lanyards') && !canvasObj.tab_name.toLowerCase().includes('color')) {
          selectedOption = '<span class="pz-selected-option">' + canvasObj.option_name + '</span>';
        }
        if (canvasObj.thumbImage && canvasObj.tab_name.toLowerCase() != 'width') {
          var pzOptionThumbImg = canvasObj.thumbImage ? props.pzImgUrl.concat(canvasObj.thumbImage.replace(props.pzReplaceImg, '')) : '';
          selectedOption += ' <span class = "pz-selected-option-thumb"><img src="' + pzOptionThumbImg + '" style="width:20px; height:20px; object-fit: cover" /></span>';
        } else if (canvasObj.value && canvasObj.tab_name.toLowerCase() != 'width') {
          selectedOptionstyle = "background: " + canvasObj.value + ";width: 20px; height: 20px; border-radius: 50%";
          selectedOption += '<span class="pz-selected-option-color" style="' + selectedOptionstyle + '"></span>';
        }
      } else if (canvasObj && canvasObj.customType == "text" && canvasObj.text != "") {
        selectedOption += '<span class="pz-selected-text"><i class="fa fa-check" aria-hidden="true"></i></span>';
      }

      var pzSubDisplay = {};
      var pzSubTabDetail = {};
      var subtabs = Object.keys(props.pzCustomizer.subtabs).length > 0 ? props.pzCustomizer.subtabs[pzTab.promize_tab_id] : {};
      subtabs && Object.keys(subtabs).length > 0 && Object.keys(subtabs).map(function (tabKey, index) {
        // if (subtabs[tabKey].parent_tab_id == pzTab.promize_tab_id) {
        //   pzSubDisplay = JSON.parse(props.pzTabs[tabKey].additional_data);
        //   pzSubTabDetail = props.pzTabs[tabKey];
        // }
        if (Object.keys(props.pzActiveOptions).length > 0) {
          return Object.keys(props.pzActiveOptions).map(function (active_Option) {
            if (parseInt(subtabs[tabKey].parent_option_id) == parseInt(props.pzActiveOptions[active_Option][1])) {
              pzSubDisplay = JSON.parse(props.pzTabs[tabKey].additional_data);
              pzSubTabDetail = props.pzTabs[tabKey];
            }
          });
        }
      });
      if (pzTab.is_sub_tab == 1 || props.pzHideTabs.includes(pzTab.promize_tab_id)) {
        return '';
      }

      if (props.popup && pzTab.tab_name.toLowerCase() === "background") {
        return React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { key: index, className: props.pzActiveTab[pzTab.promize_section_id] == pzTab.promize_tab_id && props.pzActiveSection == pzTab.promize_section_id ? 'pz-custom-items open' : props.pzActiveSection != pzTab.promize_section_id ? 'pz-custom-items hide' : 'pz-custom-items' },
            React.createElement(
              'div',
              { className: 'pz-custom-item-header', onClick: function onClick(e) {
                  e.preventDefault(), props.HomeComponent.pzSetSelectedTab(pzTab.promize_tab_id, pzTab);
                } },
              pzTab.tab_icon && React.createElement(
                'div',
                { className: 'pz-tab-icon' },
                React.createElement('img', { src: props.pzImgUrl.concat(pzTab.tab_icon.replace(props.pzReplaceImg, '')), style: { width: 20, height: 20 } })
              ),
              React.createElement(
                'h4',
                { className: 'pz-item-header' },
                React.createElement(
                  'span',
                  { className: 'pz-item-title-text' },
                  pzTab.tab_name
                )
              )
            ),
            React.createElement('div', { className: 'pz-custom-item-body ' + pzTab.tab_name.toLowerCase().replace(/\s/g, '-') })
          ),
          pzSubDisplay && pzSubDisplay.inherit && pzSubDisplay.inherit == 2 && React.createElement(PromizeSubTab, _extends({ pzSubTabDetail: pzSubTabDetail }, props))
        );
      } else if (pzTab.tab_name.toLowerCase() === "background") {
        return React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { key: index, className: props.pzActiveTab[pzTab.promize_section_id] == pzTab.promize_tab_id && props.pzActiveSection == pzTab.promize_section_id ? 'pz-custom-items open' : props.pzActiveSection != pzTab.promize_section_id ? 'pz-custom-items hide' : 'pz-custom-items' },
            React.createElement(
              'div',
              { className: 'pz-custom-item-header', onClick: function onClick(e) {
                  e.preventDefault(), props.HomeComponent.pzSetSelectedTab(pzTab.promize_tab_id, pzTab);
                } },
              pzTab.tab_icon && React.createElement(
                'div',
                { className: 'pz-tab-icon' },
                React.createElement('img', { src: props.pzImgUrl.concat(pzTab.tab_icon.replace(props.pzReplaceImg, '')), style: { width: 20, height: 20 } })
              ),
              React.createElement(
                'h4',
                { className: 'pz-item-header' },
                React.createElement(
                  'span',
                  { className: 'pz-item-title-text' },
                  pzTab.tab_name
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'pz-custom-item-body ' + pzTab.tab_name.toLowerCase().replace(/\s/g, '-') },
              React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'p',
                  { 'class': 'pz-upload-text' },
                  React.createElement(
                    'span',
                    { 'class': 'sm-hide' },
                    ' To create custom lanyard background '
                  ),
                  React.createElement(
                    'span',
                    { 'class': 'pz-text-hglt', onClick: function onClick(e) {
                        e.preventDefault(), props.pzOpenPopup();
                      } },
                    'Click Me'
                  ),
                  ' '
                ),
                React.createElement(
                  'div',
                  { style: { display: 'none' } },
                  React.createElement(PromizeAttribute, _extends({ pzTab: pzTab, pzTabType: 'Tab' }, props))
                )
              )
            )
          )
        );
      } else {
        var pzTabAdditionalData = pzTab.additional_data ? JSON.parse(pzTab.additional_data) : '';
        return React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { key: index, className: props.pzActiveTab[pzTab.promize_section_id] == pzTab.promize_tab_id && props.pzActiveSection == pzTab.promize_section_id ? 'pz-custom-items open' : props.pzActiveSection != pzTab.promize_section_id || pzTabAdditionalData && pzTabAdditionalData.tab_code == "back_text_image" && props.pzIsCopyRepeatObjects ? 'pz-custom-items hide' : 'pz-custom-items' },
            React.createElement(
              'div',
              { className: 'pz-custom-item-header', onClick: function onClick(e) {
                  e.preventDefault(), props.HomeComponent.pzSetSelectedTab(pzTab.promize_tab_id, pzTab);
                } },
              pzTab.tab_icon && React.createElement(
                'div',
                { className: 'pz-tab-icon' },
                React.createElement('img', { src: props.pzImgUrl.concat(pzTab.tab_icon.replace(props.pzReplaceImg, '')), style: { width: 20, height: 20 } })
              ),
              React.createElement(
                'h4',
                { className: 'pz-item-header' },
                React.createElement(
                  'span',
                  { className: 'pz-item-title-text' },
                  pzTab.tab_name
                )
              ),
              selectedOption && React.createElement(
                'h4',
                { className: 'pz-item-header' },
                React.createElement('span', { className: 'pz-selected-option-container', dangerouslySetInnerHTML: { __html: selectedOption } })
              )
            ),
            React.createElement(
              'div',
              { className: 'pz-custom-item-body ' + pzTab.tab_name.toLowerCase().replace(/\s/g, '-') },
              React.createElement(PromizeAttribute, _extends({ pzTab: pzTab, pzTabType: 'Tab' }, props)),
              subtabs && Object.keys(subtabs).length > 0 && Object.keys(subtabs).map(function (tabKey, index) {
                if (subtabs[tabKey].parent_tab_id == pzTab.promize_tab_id) {
                  return React.createElement(PromizeSubTab, _extends({ pzSubTabDetail: props.pzTabs[tabKey] }, props));
                }
              }),
              pzSubDisplay && pzSubDisplay.inherit && pzSubDisplay.inherit == 1 && React.createElement(PromizeSubTab, _extends({ pzSubTabDetail: pzSubTabDetail }, props))
            )
          ),
          pzSubDisplay && pzSubDisplay.inherit && pzSubDisplay.inherit == 2 && React.createElement(PromizeSubTab, _extends({ pzSubTabDetail: pzSubTabDetail }, props))
        );
      }
    })
  );
};